import { useRecommendedSimilarProductsQuery } from '@/graphql/generated/hooks'
import type { GraphQLProductType } from '@/utils/product/product-card.util'

interface UseJustViewedProductContainerHookProps {
  productId: string
  onCompleted?: () => void
}

export const useJustViewedProductContainerHook = ({
  productId,
  onCompleted,
}: UseJustViewedProductContainerHookProps) => {
  const { data, loading: isLoading } = useRecommendedSimilarProductsQuery({
    fetchPolicy: 'cache-first',
    variables: {
      id: productId,
      pageInfo: {
        first: 20,
      },
    },
    skip: !productId,
    onCompleted: () => {
      onCompleted?.()
    },
  })

  const recommendedSimilarProducts: GraphQLProductType[] =
    data?.recommendedSimilarProducts?.edges.map((e: any) => e?.node) || []

  return {
    recommendedSimilarProducts,
    isLoading,
  }
}
